import { useState, useEffect } from "react";
import { getUsers } from "../../api/services";
import LoadingModalComponent from "../../modals/loading-modal";

export default function UserListScreen() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getUsers()
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="card">
      <LoadingModalComponent show={loading} />
      <div className="card-body">
        <div className="row">
          {data?.map((el) => (
            <div className="col-md-6 col-xxl-3">
              <div className="card">
                <div className="card-body">
                  <div className="dropdown float-end">
                    <a href="#" className="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="mdi mdi-dots-horizontal" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end">
                      <a href="javascript:void(0);" className="dropdown-item"></a>
                      <a href="javascript:void(0);" className="dropdown-item"></a>
                    </div>
                  </div>
                  <div className="text-center">
                    <img src="/assets/images/users/avatar-1.jpg" className="rounded-circle avatar-md img-thumbnail" alt="friend" />
                    <h4 className="mt-3 my-1">
                      <a href="pages-profile-2.html" className="text-reset">{el.name}</a>
                    </h4>
                    <p className="mb-0 text-muted">Эрх: {el.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
